import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { BillingInterval, PlanType } from "sdk/types";
import { useShowReferAFriend } from "~/features/Referral/useShowReferAFriend";
import { useTrialDiscount } from "~/MemberApp/hooks";
import { PromoCodeField } from "./PromoCodeField";
import { ReferAFriendDiscount } from "./ReferAFriendDiscount";
import { TrialDiscount } from "./TrialDiscount";

interface Props {
  billingInterval: BillingInterval;
  fullPrice: number;
  type: PlanType;
}

export const PromoCodeSection: FC<Props> = ({
  billingInterval,
  fullPrice,
  type,
}) => {
  const trialDiscount = useTrialDiscount();
  const showTrialDiscount = trialDiscount?.discount;
  const showReferAFriend = useShowReferAFriend() && !showTrialDiscount;
  const eligibleForPromoCode = billingInterval == "1-month";
  const showPromoCode =
    !showTrialDiscount && !showReferAFriend && eligibleForPromoCode;

  if (billingInterval != "1-month") {
    return null;
  }

  return (
    <Flex w="100%">
      {showPromoCode && (
        <PromoCodeField
          billingInterval={billingInterval}
          fullPrice={fullPrice}
        />
      )}
      {showReferAFriend && <ReferAFriendDiscount fullPrice={fullPrice} />}
      {showTrialDiscount && <TrialDiscount type={type} />}
    </Flex>
  );
};
